import React from "react";
import { useTranslation } from "react-i18next";
import { BookOpen, Users, Compass, ArrowRight } from "lucide-react";
import Hero from "../components/home/Hero";
import StatsBar from "../components/home/StatsBar";
import NetworkMap from "../components/home/NetworkMap";
import FeaturedPrograms from "../components/home/FeaturedPrograms";
import MentorOpps from "../components/home/MentorOpps";
import Communities from "../components/home/Communities";
import Team from "../components/home/Team";
import PubsEvents from "../components/home/PubsEvents";
import HubJoin from "../components/home/HubJoin";
import SectionHead from "../components/SectionHead";
import { Reveal } from "../components/motion";

const PILLARS = [
  { Icon: BookOpen, k: "p1" },
  { Icon: Users, k: "p2" },
  { Icon: Compass, k: "p3" },
];

function WhyGXR() {
  const { t } = useTranslation();
  return (
    <section className="surface-1 py-20 lg:py-28" data-testid="home-why">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12">
        <SectionHead kicker={t("home.why_title")} title={t("home.ribbon.title")} to="/about" linkLabel={t("common.learnMore")} />
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {PILLARS.map(({ Icon, k }, i) => (
            <Reveal key={k} delay={i * 0.12}>
              <div className="gxr-card group relative overflow-hidden p-8 lg:p-10 h-full" data-testid={`home-why-${k}`}>
                <div className="absolute -bottom-8 ltr:-right-2 rtl:-left-2 font-display text-[180px] leading-none text-forest/[0.04] pointer-events-none select-none">
                  {t(`home.why.${k}_num`)}
                </div>
                <span className="absolute top-0 ltr:left-0 rtl:right-0 h-[3px] w-14 bg-gold transition-all duration-500 group-hover:w-full" />
                <span className="icon-tile"><Icon className="h-5 w-5" /></span>
                <div className="relative mt-8 text-[11px] font-bold tracking-[0.3em] text-gold">{t(`home.why.${k}_num`)}</div>
                <h3 className="relative font-display text-[28px] mt-3 leading-[1.1] text-ink">{t(`home.why.${k}_title`)}</h3>
                <p className="relative mt-4 text-slate text-[15px] leading-relaxed max-w-[36ch]">{t(`home.why.${k}_body`)}</p>
                <div className="relative mt-8 flex items-center gap-2 text-forest opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="h-px w-8 bg-gold" /><ArrowRight className="h-3.5 w-3.5 rtl:rotate-180" />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <div data-testid="page-home">
      <Hero />
      <StatsBar />
      <NetworkMap />
      <FeaturedPrograms />
      <WhyGXR />
      <MentorOpps />
      <Communities />
      <PubsEvents />
      <Team />
      <HubJoin />
    </div>
  );
}
